module.exports = __webpack_public_path__ + "static/media/200525_esf-berlin_final.3d1e7fce.jpeg";